import { j as l } from "./jsx-runtime-3tyXYecC.mjs";
import { _ as ar } from "./composeRefs-YONvD-rx.mjs";
import { c as W } from "./index-DkZ16bcJ.mjs";
import { l as ir } from "./lodash-5ofSKtz3.mjs";
import { f as d, h as fr, i as cr, j as U, k as X, l as ur, m as dr, u as hr, c as lr, d as gr, n as yr, o as pr, p as mr, q as _, C as wr, r as Cr, t as Mr, s as br, v as q, b as kr, w as Er, x as Fr, y as Ar } from "./date-picker-utils-provider-CwC1AjFc.mjs";
import { forwardRef as xr, useState as M, useRef as jr, useEffect as vr } from "react";
import { G as Sr } from "./grid-row-D1eZQbHo.mjs";
import { S as Ir } from "./screen-reader-only-text-B-XgpPEP.mjs";
import { f as y } from "./index-LyFokDcn.mjs";
import { m as Rr } from "./tss-DN0acMKN.mjs";
import { M as Yr, d as Br } from "./constants-CnFYFetN.mjs";
import { F as Pr } from "./flex-Cc3osQLf.mjs";
function Dr(r) {
  return {
    value: r
  };
}
function G(r, t, a, o, i, s) {
  if (!r || !d(r, t))
    throw new Error("Expected arguments are missing.");
  return a ? !0 : X(r, t, o, i, s);
}
function Kr(r, t, a, o, i, s) {
  if (!r || !d(r, t))
    throw new Error("Expected arguments are missing.");
  return !r.isEqual(t, a) || !a || !d(r, a) ? !1 : d(r, a) && o && d(r, o) && r.isBeforeDay(a, o) || d(r, a) && i && d(r, i) && r.isAfterDay(a, i) ? !0 : s ? s(a) : !1;
}
function H(r, t, a, o) {
  if (!r || !t || !d(r, t))
    throw new Error("Expected arguments are missing.");
  return o || !a ? !1 : r.isSameDay(t, a);
}
function Or(r, t, a, o) {
  if (!r || !t)
    throw new Error("Expected arguments are missing.");
  return a || d(r, o) && fr(r, t, o);
}
function Nr(r, t, a, o) {
  if (!r || !t)
    throw new Error("Expected arguments are missing.");
  return a || d(r, o) && cr(r, t, o);
}
function Tr(r, t) {
  if (!r)
    throw new Error("Expected arguments are missing.");
  return t && d(r, t) ? r.startOfMonth(t) : r.startOfMonth(U(r));
}
const Vr = Rr()((r) => {
  const { constructs: t, mixins: a, mode: o, palette: i, borderRadiuses: s } = r;
  return {
    hidden: {
      visibility: "hidden"
    },
    picker: {
      backgroundColor: o === Yr.Dye ? Br.main : y.ifFeature("encore", t.surface.neutral.xxWeak, i.gray[100]),
      borderRadius: y.ifFeature("encore", s[200]),
      overflow: "hidden",
      position: "relative",
      "& .MuiCalendarPicker-root > div > div > div:first-of-type": {
        marginBottom: 0,
        padding: 0
      },
      // @startCleanup encore
      width: y.ifFeature("encore", void 0, 308)
      // @endCleanup encore
    },
    root: {
      background: y.ifFeature("encore", t.surface.neutral.forcedWhite),
      borderBottom: a.border(1, "transparent"),
      borderRadius: y.ifFeature("encore", s[200]),
      margin: 0,
      padding: y.ifFeature("encore", "4px"),
      width: y.ifFeature("encore", "320px", "308px")
    }
  };
});
function F(r, t, a = {}, o = t) {
  const i = ur(
    r,
    t,
    r.startOfDay(r.endOfMonth(t)),
    a
  );
  if (!X(r, o, i.minDate, i.maxDate, i.getDateDisabled))
    return o;
  const { next: s, previous: f } = dr(r, o, i);
  return s || f;
}
function Lr({
  autofocus: r = !1,
  classes: t = {},
  className: a,
  disabled: o = !1,
  getDateDisabled: i,
  maxDate: s,
  minDate: f,
  onChange: z,
  onMenuClose: A,
  onMenuOpen: x,
  renderDate: j,
  value: m = Cr.local()
}, J) {
  const n = hr(), [h, w] = M(() => Tr(n, m)), b = jr(null), [g, C] = M(Z), [v, S] = M(!1), [Q, k] = M(!1);
  function Z() {
    const e = m || U(n);
    return F(n, h, { getDateDisabled: i, maxDate: s, minDate: f }, e);
  }
  function I() {
    var u;
    if (!b.current)
      return;
    const e = Mr(b.current);
    if (ir.findLast(e, (p) => p.hasAttribute("data-calendar-day"))) {
      k(!0);
      return;
    }
    (u = e[0]) == null || u.focus();
  }
  vr(() => {
    r && I();
  }, [r]);
  const { classes: R } = Vr();
  f = d(n, f) ? f : lr(n), s = d(n, s) ? s : gr(n);
  const Y = yr(n, f, s), B = Or(n, h, o, f), P = Nr(n, h, o, s), D = pr(n), K = n.getYear(h), O = n.getMonth(h) + 1;
  function N(e) {
    const c = g && q(
      n,
      g,
      n.getMonth(e),
      n.getYear(e)
    ), u = F(
      n,
      e,
      {
        getDateDisabled: i,
        maxDate: s,
        minDate: f
      },
      c
    );
    C(u), w(e);
  }
  function T(e) {
    if (e === "next-month") {
      N(n.addMonths(h, 1));
      return;
    }
    N(n.addMonths(h, -1));
  }
  function V(e, c) {
    (c === "finish" || c === !0) && (G(n, e, o, f, s, i) || (C(e), z(Dr(e)), S(!0)));
  }
  function L({ month: e, year: c }) {
    const u = br(n, c, e), p = g && q(
      n,
      g,
      n.getMonth(u),
      n.getYear(u)
    ), E = F(
      n,
      u,
      {
        getDateDisabled: i,
        maxDate: s,
        minDate: f
      },
      p
    );
    C(E), w(u);
  }
  function rr(e, c, u) {
    const { outsideCurrentMonth: p, disabled: E, ...or } = u;
    if (j) {
      const sr = kr(n, e);
      return j(sr, c, u);
    }
    return /* @__PURE__ */ l.jsx(
      Er,
      {
        ...or,
        active: H(n, e, g, v),
        disabled: G(n, e, o || E, f, s, i),
        errored: Kr(n, e, m, f, s, i),
        focused: Q && H(n, e, g, v),
        outsideCurrentMonth: p,
        selected: n.isEqual(m, e)
      }
    );
  }
  function er(e) {
    if (e.key === " " || e.key === "Enter") {
      g && (e.preventDefault(), V(g, !0));
      return;
    }
    if (Fr(e)) {
      e.preventDefault();
      const c = Ar({
        activeDate: g,
        getDateDisabled: i,
        keyboardKey: e.key,
        maxDate: s,
        minDate: f,
        shiftKeyPressed: e.shiftKey,
        utils: n
      });
      n.isSameMonth(h, c) || w(n.startOfMonth(c)), C(c), S(!1);
    }
  }
  function nr({ currentTarget: e }) {
    e.contains(document.activeElement) || I();
  }
  const tr = mr(n, h);
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ l.jsxs("div", { className: W(R.root, a, t.root), onClick: nr, ref: ar(J, b), children: [
      /* @__PURE__ */ l.jsxs("div", { className: W(R.picker), children: [
        y.ifFeature(
          "encore",
          /* @__PURE__ */ l.jsx(Pr, { justifyContent: "center", paddingTop: 1, paddingX: 1, children: /* @__PURE__ */ l.jsx(
            _,
            {
              disabled: o,
              leftArrowDisabled: B,
              maxDate: s,
              minDate: f,
              months: D,
              monthValue: O,
              onArrowClick: (e) => T(e),
              onChange: L,
              onMenuClose: A,
              onMenuOpen: x,
              rightArrowDisabled: P,
              years: Y,
              yearValue: K
            }
          ) }),
          /* @__PURE__ */ l.jsx(Sr, { justifyContent: "center", margin: "none", marginTop: 1, marginX: 1, children: /* @__PURE__ */ l.jsx(
            _,
            {
              disabled: o,
              leftArrowDisabled: B,
              maxDate: s,
              minDate: f,
              months: D,
              monthValue: O,
              onArrowClick: (e) => T(e),
              onChange: L,
              onMenuClose: A,
              onMenuOpen: x,
              rightArrowDisabled: P,
              years: Y,
              yearValue: K
            }
          ) })
        ),
        /* @__PURE__ */ l.jsx("div", { onBlur: () => k(!1), onFocus: () => k(!0), onKeyDown: er, children: /* @__PURE__ */ l.jsx(
          wr,
          {
            date: h || null,
            maxDate: s,
            minDate: f,
            onChange: V,
            onMonthChange: (e) => w(e),
            renderDay: rr,
            weeksToShow: tr
          }
        ) })
      ] }),
      /* @__PURE__ */ l.jsx(Ir, { ariaAtomic: !0, ariaLive: "assertive", children: window.jQuery ? $.__("Showing %1$s", n.format(h, "monthAndYear")) : `Showing ${n.format(h, "monthAndYear")}` })
    ] })
  );
}
const re = xr(Lr);
export {
  re as D
};
//# sourceMappingURL=date-picker-calendar-single-Ce3WY92H.mjs.map
